import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useMemo } from 'react';
import { useLocalizeMessage, ModalWindow } from 'libs.nucleus';
import { StepFooter } from '../step_footer';
import { CreateTransferTemplateByDataBuilderStep3 } from './create_transfer_template_by_data_builder_step_3.component';
import { CreateTransferTemplateBySqlEditorStep2 } from './create_transfer_template_by_sql_editor_step_2.component';
import { CreateTransferTemplateBySqlEditorStep3 } from './create_transfer_template_by_sql_editor_step_3.component';
import { CreateTransferTemplatePivotStep } from './create_transfer_template_pivot_step.component';
import { DataTransferTemplateContext } from '../../../contexts/data_transfer_template/data_transfer_template.context';
import { useStepNavigation } from '../../hooks/use_step_navigation';
export const EditTransferTemplateModal = ({ initialData, onClose }) => {
    const translate = useLocalizeMessage();
    const { templateCreationOption, setTemplateCreationOption, isCreateFormValid, createDataTransferTemplate, setCreateTemplateFormData, isLoading, setInitialData, resetForm, setIsEditMode, pivotDataEnabled, } = useContext(DataTransferTemplateContext);
    const totalSteps = useMemo(() => {
        // In edit mode, SQL editor has 3 steps when pivot is enabled; others have 2
        if (templateCreationOption === 'sql_editor') {
            return pivotDataEnabled ? 3 : 2;
        }
        return 2;
    }, [templateCreationOption, pivotDataEnabled]);
    // Create step validations using the context state
    const stepValidations = useMemo(() => ({
        1: () => isCreateFormValid,
    }), [isCreateFormValid]);
    const { currentStep, isFirstStep, isLastStep, handleNext, handlePrevious } = useStepNavigation({
        totalSteps,
        stepValidations,
    });
    const isEditBuilder = useMemo(() => {
        if (!initialData.jsonQuery || typeof initialData.jsonQuery !== 'object') {
            return false;
        }
        const jsonQuery = initialData.jsonQuery;
        return !!(jsonQuery.query && typeof jsonQuery.query === 'object' && Object.keys(jsonQuery.query).length > 0);
    }, [initialData]);
    useEffect(() => {
        if (initialData) {
            setTemplateCreationOption(isEditBuilder ? 'data_builder' : 'sql_editor');
            setCreateTemplateFormData(initialData);
            setInitialData(initialData);
            setIsEditMode(true);
        }
    }, [initialData, setTemplateCreationOption, setCreateTemplateFormData, setInitialData, setIsEditMode, isEditBuilder]);
    const handleCloseModal = () => {
        resetForm();
        onClose();
    };
    const continueButton = {
        label: translate('Continue'),
        onClick: handleNext,
        disabled: currentStep === 1 &&
            (templateCreationOption === 'sql_editor' || isEditBuilder) &&
            (!isCreateFormValid || isLoading),
    };
    const submitButton = {
        label: translate('Update'),
        onClick: async () => {
            await createDataTransferTemplate();
            handleCloseModal();
        },
        disabled: isLoading || !isCreateFormValid,
    };
    const footerSecondaryActionButtons = [
        {
            label: translate('Cancel'),
            onClick: handleCloseModal,
        },
    ];
    if (!isFirstStep) {
        footerSecondaryActionButtons.push({
            label: translate('Back'),
            onClick: handlePrevious,
        });
    }
    return (_jsxs(ModalWindow, { title: translate(`Edit data transfer template`), isOpen: true, closeWindow: handleCloseModal, footerPrimaryActionButton: isLastStep ? submitButton : continueButton, footerSecondaryActionButtons: footerSecondaryActionButtons, footerCenterContent: _jsx(StepFooter, { currentStep: currentStep, totalSteps: totalSteps }), width: 'full', children: [currentStep === 1 && _jsx(CreateTransferTemplateBySqlEditorStep2, {}), currentStep === 2 && !isEditBuilder && _jsx(CreateTransferTemplateBySqlEditorStep3, {}), currentStep === 3 && !isEditBuilder && pivotDataEnabled && _jsx(CreateTransferTemplatePivotStep, {}), currentStep === 2 && isEditBuilder && _jsx(CreateTransferTemplateByDataBuilderStep3, {})] }));
};
